import { Navigate } from "react-router-dom";
import config from "config";

const { tokenKey } = config;
function Home() {
  if (!localStorage.getItem(tokenKey)) return <Navigate to="/login" />;
  return <Navigate to="/dashboard/home" />;
}

export default Home;
